import React from 'react';

// import CloudinaryPlayer from './video-player';
import VimeoPlayer from './VimeoPlayer';

// const FVPlayer = () => (
//       <VimeoPlayer />
// );

const FVPlayer = (props) => {
  return <VimeoPlayer responsive={props.responsive} video_source={props.source} />;
};
export default FVPlayer;
